
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#gst-tenants-aadvantagehotels-app-modules-hotel-assets-svg-amenities-late-checkout_svg-a)","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M12.027 21.503v-2m0-17v2m9.5 7.5h-2m-17 0h2m14.217-6.717L17.33 6.7M5.309 18.721l1.415-1.414M5.309 5.286L6.724 6.7m12.02 12.021l-1.414-1.414m-5.303 6.196c6.351 0 11.5-5.149 11.5-11.5s-5.149-11.5-11.5-11.5-11.5 5.149-11.5 11.5 5.149 11.5 11.5 11.5z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"gst-tenants-aadvantagehotels-app-modules-hotel-assets-svg-amenities-late-checkout_svg-a"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    